import React from "react";
import HttpService from '../utils/Http.services';
import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../components/Configurer";

// import FixedView from "../components/FixedView";
// import { widgetsList } from "../variables/widgetsList";
// import GaugeChart from 'react-gauge-chart'
// import WidgetContainer from "../components/widgets/WidgetContainer";
// import { nanoid } from "nanoid";
// import DraggableList from "../components/dragLibrary/DraggableList";
// import DraggableGrid from "../components/dragLibrary/DraggableGrid";
import LoaderButton from "../components/LoaderButton";
import { pathMaker, translate } from "../utils/useful";
import PageStatusViewer from "../components/PageStatusViewer";
import TLink from "../components/TLink";
import WidgetComponents from "../components/widgets/WidgetComponents";
import RemoveConfirmationModal from "../modals/RemoveConfirmationModal";
import { withRouter } from "react-router";



class Dashboard extends React.Component {


    state = {
        info: { modules: [] },
        data: [],
        // widgetsList: [
        //     1, 1, 1, 1, 1
        // ]
    }

    componentDidMount() {

        let id = this.props.match.params.id
        console.log(id)

        if (id) {
            this.getDashboard(id)
        } else {
            let info = this.state.info
            info.name = 'Dashboard Name'
            info.description = 'Dashboard description can be shown here'
            info.modules = []
            this.setState({ pageStatus: 200, info })

        }

    }

    getDashboard = (id) => {

        this.setState({ isLoading: true })

        HttpService.request("getDashboard", { id }, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoading: false })


            this.setState({ pageStatus: fetchStatus })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                return
            }
            this.setState({ info: fetchResult.info })

        })
    }




    removeConfirmed = () => {

        HttpService.request("removeDashboard", { id: this.state.info._id }, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoading: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }

            this.props.history.push(pathMaker('/'))
            // this.setState({ info: fetchResult.info })

        })

    }



    removeButton(action, showInMobile) {
        return (
            <div className={"flexc " + (showInMobile ? '' : 'd-none d-md-block')}>

                <LoaderButton
                    onClick={() => action()}
                    isLoading={this.state.isLoadingRemove}
                    text={translate("Remove")}
                    type={"Oval"}
                    className=""
                    buttonStyle={{ outline: 'none', backgroundColor: '#F87C56b7fb7f', cursor: 'pointer', padding: '5px 20px', borderRadius: 30, fontSize: 13, fontWeight: 'bold', color: '#fff', border: 'none' }}
                    width={30}
                    height={30}
                    color={'#202020'}
                />
                {/* <button className="" onClick={() => action()} style={{ backgroundColor: '#222530', color: '#fff', borderRadius: 40, padding: '5px 20px', fontWeight: 'bold' }}>SAVE</button> */}
                {/* <button onClick={() => this.props.nextStage()} style={{ backgroundColor: '#202020', color: '#fff', borderRadius: 30, padding: '5px 15px', fontWeight: 'bold' }}>NEXT</button> */}
            </div>
        )
    }


    editButton(action, showInMobile) {
        return (
            <div className={"flexc mx-1 " + (showInMobile ? '' : 'd-none d-md-block')}>
                <TLink className="" to={'/editDashboard/' + this.state.info._id} style={{ backgroundColor: '#222530', fontSize: 13, color: '#fff', borderRadius: 40, padding: '5px 20px', fontWeight: 'bold' }}>Edit</TLink>
            </div>
        )
    }

    openRemoveConfirmation = () => {
        this.RemoveConfirmationModal.modal.showModal()
    }

    render() {
        return (

            <Configurer
                settingsInfo={{
                    showFooter: true, showTabBar: true, showHeader: true, headerTitle: this.state.info?.name, button: {},
                    headerButtons: this.state.pageStatus == 200 ? [this.removeButton(this.openRemoveConfirmation), this.editButton()] : null,
                }}
                update={this.state.updateConfigurer}

                title={"Dashboard | " + this.state.info?.name}
                description={this.state.info?.description}
                className="pt-0"
            >

                <PageStatusViewer status={this.state.pageStatus}>

                    <div className="">

                        <div className="" style={{ padding: '20px 3% 20px 3%', backgroundColor: '#f2f6f8', minHeight: '100vh', }}>

                            <div className="flexcc mb-3 d-md-none ">
                                {this.removeButton(this.openRemoveConfirmation, true)}
                                {this.editButton(null, true)}

                            </div>

                            <div className="row m-0">

                                {/* <DraggableGrid dragstarted={this.dragStarted} dragover={this.dragOver} data={this.state.data} updatedata={this.updateData} width={400}> */}
                           
                                {this.state.info.modules.map((prop) => {

                                    let Component = WidgetComponents[prop.key]
                                    if (Component) {
                                        return (
                                            <div className={"mb-1 p-1 col-12  col-md-" + (prop.col ?? "4")} key={prop._id}>
                                                {/* <div className="h-100"> */}
                                                <div className="h-100 py-2 px-2 d-flex flex-column" style={{ backgroundColor: '#fff', borderRadius: 4 }}>
                                                    <p className="text-center text-bold mt-2 mb-2 text-small">{prop.title}</p>
                                                    <Component data={prop} dashboard={this.state.info} />
                                                </div>
                                                {/* </div> */}
                                            </div>
                                            // <WidgetContainer grid={prop.grid} id={prop.id} key={prop.id} data={prop} openMore={this.openMore} />
                                        )
                                    } else {
                                        console.log("*******")
                                        console.log(prop.key)
                                    }
                                })}

                                {/* </DraggableGrid> */}
                            </div>
                        </div>

                        <RemoveConfirmationModal ref={el => this.RemoveConfirmationModal = el} confirmed={this.removeConfirmed} />

                    </div>
                </PageStatusViewer>

            </Configurer>
        )
    }

}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Dashboard));
